import type { AllRouteEndpoints } from "../routeTypes";
export const engagementLinkAliasesUpdateLinksCacheKeys: AllRouteEndpoints[] = [
  "/engagement/link_aliases/get_tracked_links",
];

export const engagementLinkAliasesUpdateLinks = "/engagement/link_aliases/update_links";
